<template>
  <el-date-picker
    style="width: 100%;"
    :type="type"
    :value="dateValue"
    :start-placeholder="$t(startPlaceholder)"
    :end-placeholder="$t(endPlaceholder)"
    v-bind="$attrs"
    @input="changeDate"
  />

</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    prop: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: 'daterange'
    },
    startPlaceholder: {
      type: String,
      default: ''
    },
    endPlaceholder: {
      type: String,
      default: ''
    }
  },
  computed: {
    dateValue() {
      return [
        this.data[this.prop[0]] || '',
        this.data[this.prop[1]] || ''
      ]
    }
  },
  watch: {
    dateValue(value) {
      if (!value[0] && !value[1]) {
        this.$emit('input', '')
      } else if (value[0] && value[1]) {
        const label = value.join(' - ')
        this.$emit('input', label, label)
      }
    }
  },
  methods: {
    changeDate(value = []) {
      value = value === null ? [] : value
      this.prop.forEach((key, index) => {
        if (key && key in this.data) {
          this.data[key] = value[index]
        }
      })
      const label = this.dateValue.join(' - ')
      this.$emit('input', label, label)
    }
  }
}
</script>
